<template>
  <button
    :class="classess"
    @click="$emit('click')"
    :type="type"
    :disabled="loading || disabled"
    :id="id"
  >
    {{ label }}
    <i :class="`fa fa-${icon} ml-2`" v-if="!loading"></i>
    <b-spinner small variant="light" class="ml-2" v-if="loading"></b-spinner>
  </button>
</template>

<script>
export default {
  props: ["label", "type", "loading", "variant", "icon", "size", "id", "disabled"],
  computed: {
    classess() {
      let classes = "dm-button ";
      if (this.variant == "danger") {
        classes += "danger ";
      } else {
        classes += "primary ";
      }

      if (this.size == "sm") {
        classes += "small ";
      }
      return classes;
    }
  }
};
</script>

<style scoped>
.dm-button {
  outline: none;
  border: none;
  width: 100%;
  padding: 7px 15px;
  border-radius: 7px;
  transition: all 0.3s ease;
  white-space: nowrap;
  color: #fff;
}
.dm-button:disabled {
  background: grey;
  cursor: not-allowed;
}
.dm-button:hover {
  box-shadow: var(--shadow);
}

.small {
  width: auto !important;
  padding: 5px 15px;
}

.primary {
  background: var(--primary-color);
  color: #fff;
}
.danger {
  background: #ff0000;
  color: var(--white);
}
</style>
